(function () {
    angular.module('core')
      .controller('StudentProgressModalController', [
          '$injector',
          '$filter',
          '$modalInstance',
          '$scope',
          'dblLessonService',
          'dblStandardsFactoryService',
          'moment',
          'progressApi',
          'progressData',
          'dblPrintService',
          'edxAcademicMappingsApi',
          'assignedFocusApi',
          'localeService',
          '$log',
          StudentProgressModalController]);

    function StudentProgressModalController(
      $injector,
      $filter,
      $modalInstance,
      $scope,
      dblLessonService,
      dblStandardsFactoryService,
      moment,
      dblProgressApi,
      progressData,
      dblPrintService,
      edxAcademicMappingsApi,
      assignedFocusApi,
      localeService,
      $log
    ) {
        // using injector since we can inject only 18 services in the constructor
        var $q = $injector.get('$q');
        var $configuration = $injector.get('configuration');
        $scope.getProgressLabel = getProgressLabel;
        $scope.isDomainReport = isDomainReport;
        $scope.getStudentStatusAlertClass = getStudentStatusAlertClass;
        $scope.getStudentStatusText = getStudentStatusText;
        $scope.getAssignmentStatusClass = getAssignmentStatusClass;
        $scope.getAssignmentStatusText = getAssignmentStatusText;
        $scope.shouldShowStudentStatusText = shouldShowStudentStatusText;
        $scope.handlePlayDemoClick = handlePlayDemoClick;
        $scope.cancel = cancel;

        // Make sure there aren't any old progress modal copies sitting around in the print section
        // that may interfere (currently print copies the id of the modal into the print section)
        dblPrintService.resetPrintSection();
        $scope.progressData = progressData;

        // TODO: improve how these messages are generated and displayed.  Display logic
        // is split between server and JS making this code brittle.  If the message
        // text on the server is changed, these messages won't display properly.
        var ASSIGNMENT_STATUS_TEXT = {
            GOAL_REACHED: 'Goal Reached',
            GOAL_NOT_REACHED: 'Goal Not Reached',
            COMPLETED_ALL_AVAILABLE: 'Completed All Available'
        };

        var SHOWABLE_ASSIGNMENT_STATUS_TEXTS = _.values(ASSIGNMENT_STATUS_TEXT);

        function init() {
            moment.locale(localeService.getLocale());

            // Localise the assignment status text
            ASSIGNMENT_STATUS_TEXT.GOAL_REACHED = $filter('translate')('assignments.goalStatus.GOAL_REACHED');
            ASSIGNMENT_STATUS_TEXT.GOAL_NOT_REACHED = $filter('translate')('assignments.goalStatus.GOAL_NOT_REACHED');
            ASSIGNMENT_STATUS_TEXT.COMPLETED_ALL_AVAILABLE = $filter('translate')('assignments.goalStatus.COMPLETED_ALL_AVAILABLE');

            $scope.from_date = moment($scope.progressData.from_date, 'YYYYMMDD').format('ll');
            $scope.to_date = moment($scope.progressData.to_date, 'YYYYMMDD').format('ll');
            $scope.duration = moment($scope.progressData.to_date, 'YYYYMMDD').diff(moment($scope.progressData.from_date, 'YYYYMMDD'), 'weeks');

            // Handles when all dates selected are in the future
            $scope.isFuture = moment($scope.progressData.from_date, 'YYYYMMDD').isAfter(moment());
            $scope.isPast = moment($scope.progressData.to_date, 'YYYYMMDD').endOf('day').isBefore(moment().endOf('day'));

            $scope.minutes_wk = 0;
            $scope.lessonsInAssignmentCount = 0;
            $scope.otherLessonsInFocusCount = 0;
            $scope.struggling = false;

            $scope.progressData.assessment = assignedFocusApi.thirdPartyTitle($scope.progressData);
            _setFlagIfFocusIsInAnAcademicProgram();
            getStudentGoalReport();
        }

    /**
     * Checks if the focus_id/focus_type reference an academic program vs academic standard
     * We need to know if the assignment is for an academic program so we can customize the progress text to be
     * Progress instead of Proficiency.  Ideally, we would just determine the academic type, instead of a flag, but no
     * APIs exist currently which could determine that in a general way.  Adding a new API seems like overkill since
     * we have no reason to believe that there will ever be more than the two academic types 'PROGRAM' and 'STANDARD'
     * @private
     */
    function _setFlagIfFocusIsInAnAcademicProgram() {
      var moGroupDescPromise = dblProgressApi.getStandardData(
        $scope.progressData.focus_type.toLowerCase(),
        $scope.progressData.focus_id).then(function (moGroupDesc) {
        return moGroupDesc.data;
      });

      var academicProgramsPromise = edxAcademicMappingsApi.getAcademicMappings(edxAcademicMappingsApi.ACADEMIC_PROGRAM);

      $q.all([moGroupDescPromise, academicProgramsPromise]).then(function (results) {
        var moGroupDesc = results[0];
        var academicPrograms = results[1];

        var ast = _.find(academicPrograms, function (program) {
          return program.id === moGroupDesc.academic_standard_id;
        });
        $scope.isAcademicProgram = !!ast;
      });
    }

    function getLessonStatusText(paused) {
      var text = paused ?
        dblLessonService.LESSON_STATUS.PAUSED :
        dblLessonService.LESSON_STATUS.COMPLETED;

      return $filter('translate')(text);
    }

    function getUnderstandingText(passed, struggling) {
      if (_.isNull(passed)) {
        if (!struggling) {
          return '';
        } else {
          return $filter('translate')(dblLessonService.LESSON_UNDERSTANDING.STRUGGLING);
        }
      }

      if (!_.isBoolean(passed)) {
        return '';
      }

      return $filter('translate')(passed ?
        dblLessonService.LESSON_UNDERSTANDING.YES :
        dblLessonService.LESSON_UNDERSTANDING.NO);
    }

    function getWeekLabel(week, currentWeek) {
      if (currentWeek === week) {
        return $filter('translate')('assignments.currentWeek');
      }

      return $filter('translate')('assignments.weekX', { x: week });
    }

    function filterHistoryData() {
      var historyDataComplete = angular.copy($scope.report.student_histories);
      var historyDataTrimmed = [];
      var lessonsByWeek = {};

      _.each(historyDataComplete.reverse(), function (history_item) {

        // time_comp is of the form "2017-01-19T00:00:00.000Z".  Z = UTC.
        var lessonCompletionDate = moment(history_item.time_comp);
        // from_date has no time zone specified and should be interpreted as being
        // in the district time zone. This parsing assumes the browser time zone
        // is the same as the district time zone.
        var assignmentStartDate = moment($scope.progressData.from_date, 'YYYYMMDD');
        var durationInDays = lessonCompletionDate.diff(assignmentStartDate, 'days');
        // durationInDays can be zero if the assignment is completed on the first day.
        // Here we set a minimum duration of 1 so such an assignment will be in week 1 instead of a week 0.
        // This means the first "week" will contain 8 days instead of 7, but this is consistent
        // with how weeks are calculated in dblProgressLineChart.
        var durationInDaysAdjusted = Math.max(durationInDays, 1);

        history_item.week = Math.ceil(durationInDaysAdjusted / 7);

        var weekLessons = lessonsByWeek[history_item.week];

        if (!weekLessons) {
          weekLessons = [];
          lessonsByWeek[history_item.week] = weekLessons;
        }

        $scope.minutes_wk += history_item.time_spent_millis;

        if (history_item.was_lesson_passed === null) {
          var lesson = _.find(weekLessons, function (lesson) {
            return lesson.lesson_slot_id === history_item.lesson_slot_id;
          });

          if (lesson) {
            lesson.time_spent_millis += history_item.time_spent_millis;
          } else {
            weekLessons.unshift(history_item);
            historyDataTrimmed.push(history_item);
          }
        } else {
          weekLessons.unshift(history_item);
          historyDataTrimmed.push(history_item);
        }

        history_item.status_text = getLessonStatusText(_.isNull(history_item.was_lesson_passed));
        history_item.understanding_text = getUnderstandingText(history_item.was_lesson_passed, history_item.was_struggling);
      });

      var lessonsNotPaused = _.filter(historyDataTrimmed, function (item) {
        if (item.was_lesson_passed !== null) {
          return item;
        }
      });

      var lessonsInAssignmentNotPaused = _.filter(lessonsNotPaused, function (lesson) {
        return lesson.assignment_id === $scope.progressData.assignment_id;
      });

      $scope.historyDataTrimmed = historyDataTrimmed.reverse();
      $scope.lessonsInAssignmentCount = lessonsInAssignmentNotPaused.length;
      $scope.otherLessonsInFocusCount = lessonsNotPaused.length - $scope.lessonsInAssignmentCount;
      $scope.minutes_wk = $scope.minutes_wk / 60000;
    }

    function getStudentHistoryWeeks(trimmedHistoryData) {
      var fromMoment = moment($scope.progressData.from_date, 'YYYYMMDD');
      var toMoment = moment($scope.progressData.to_date, 'YYYYMMDD');
      var isComplete = $scope.progressData.isStatusComplete;
      var currentWeek = Math.floor(moment.duration(moment() - fromMoment).asWeeks()) + 1;
      var endWeek = Math.ceil(moment.duration(toMoment - fromMoment).asWeeks());
      var weeks = [];

      var lastWeek;

      if (isComplete) {
        if (trimmedHistoryData.length > 0) {
          // If the assignment is already complete, only show up to the week where the student completed it.
          // This is presumed to be the last week there's any activity.
          lastWeek = _.max(_.map(trimmedHistoryData, 'week'));
        } else {
          // If the student has already completed the assignment on their own, show nothing.
          return [];
        }
      } else {
        // If the student has not completed the lesson, show all the weeks the lesson was assigned, up to
        // the present, whether the student worked on them or not.
        lastWeek = Math.min(currentWeek, endWeek);
      }

      for (var i = 0; i < lastWeek; i++) {
        weeks[i] = {week: i + 1, weekLabel: getWeekLabel(i + 1, currentWeek), items: []};
      }

      _.each(trimmedHistoryData, function (historyItem) {
        if (historyItem.week <= lastWeek) {
          weeks[historyItem.week - 1].items.push(historyItem);
        } else {
          $log.warn('StudentProgressModalController: activity takes place in the future');
        }
      });

      return weeks;
    }

    function setReportHeaderData() {
      $scope.progress = Math.abs($scope.report.proficiency_growth);
      $scope.sign = $scope.report.proficiency_growth > 0 ? '+' : $scope.report.proficiency_growth === 0 ? '' : '-';
      $scope.goalReached = ($scope.report.starting_proficiency + $scope.report.proficiency_growth) >= 100;
      $scope.proficiency = $scope.report.starting_proficiency + $scope.report.proficiency_growth;
    }

    function loadClusterOrDomainStandards(focusType) {
      var districtId = $scope.progressData.districtId;
      var studentId = $scope.progressData.student_id;
      var focusId = $scope.progressData.focus_id;
      var toDate = $scope.progressData.to_date;

      $scope.showClusterLabels = focusType === 'domain';

      dblProgressApi.getGoalStandardProgressForStudent(districtId, studentId, focusType, focusId, toDate).then(function (clusterData) {
        var clusters;

        if ($scope.isDomainReport()) {
          clusters = clusterData.clusters;
        } else {
          clusters = [_.find(clusterData.clusters, {code: focusId.toString()})];
        }

        $scope.standardData = dblStandardsFactoryService.createStandardsForClusters(clusters);

        _.each($scope.standardData.standards, function (standard) {
          if (standard.proficiency_status === "NEEDS_ATTENTION") {
            standard.struggling = true;
            $scope.struggling = true;
          }
        });
      });
    }

    function loadStandard() {
      var districtId = $scope.progressData.districtId;
      var studentId = $scope.progressData.student_id;
      var focusId = $scope.progressData.focus_id;
      var toDate = $scope.progressData.to_date;

      dblProgressApi.getGoalStandardProgressForStudent(districtId, studentId, 'standard', focusId, toDate).then(function (standardData) {
        var clusters = standardData.clusters;

        _.each(clusters, function (cluster) {
          var standard = _.find(cluster.standards, function (clusterStandard) {
            return parseInt(clusterStandard.code) === $scope.progressData.focus_id;
          });

          if (standard && standard.proficiency_status === "NEEDS_ATTENTION") {
            $scope.struggling = true;
          }
        });

        $scope.standardData = [];
      });
    }

    function loadClusterStandardTable() {
      if ($scope.isDomainReport() || $scope.progressData.focus_type === 'CLUSTER') {
        loadClusterOrDomainStandards($scope.progressData.focus_type.toLowerCase());
      } else {
        loadStandard();
      }
    }

    function getStudentGoalReport() {
      dblProgressApi.getStudentGoalReport($scope.progressData.student_id, $scope.progressData.from_date, $scope.progressData.to_date, $scope.progressData.focus_id, $scope.progressData.focus_type, function (response) {
        $scope.report = angular.copy(response.data.goal_report);

        // Get the maximum percent_complete from the proficiency list
        if( $scope.report && $scope.report.proficiency_on_date_list ) {
          var proficiencyList = $scope.report.proficiency_on_date_list.map(function (progress) { return progress.percent_complete;});
          var maxProficiency = Math.max.apply(Math, proficiencyList);
          // if the progress reached the 100% and then get lower we should shouw only until the 100%
          if ( maxProficiency === 100 &&  proficiencyList[proficiencyList.length-1] < 100) {
            var maxProficiencyIndex = proficiencyList.indexOf(maxProficiency);
            var maxProficiencyDate =new Date($scope.report.proficiency_on_date_list[maxProficiencyIndex].date);
            maxProficiencyDate.setMinutes(maxProficiencyDate.getMinutes() + maxProficiencyDate.getTimezoneOffset());
            $scope.report.proficiency_growth = maxProficiency - $scope.report.starting_proficiency;
            $scope.report.proficiency_on_date_list = $scope.report.proficiency_on_date_list.slice(0, maxProficiencyIndex + 1);
            $scope.report.student_histories = angular.copy($scope.report.student_histories).filter(function (history) {
              var historyDate = new Date(history.time_comp);
              //set same hours, minutes, seconds because proficiency_on_date_list doesn't include minutes
              maxProficiencyDate.setHours(historyDate.getHours());
              maxProficiencyDate.setMinutes(historyDate.getMinutes());
              maxProficiencyDate.setSeconds(historyDate.getSeconds());
              return historyDate <= maxProficiencyDate;
            });
          }
        }
        setReportHeaderData();
        filterHistoryData();
        loadClusterStandardTable();
        $scope.studentHistoryWeeks = getStudentHistoryWeeks($scope.historyDataTrimmed);
      });
    }

    /**
     * Returns a label to use for percent progress
     * @returns {string}
     */
    function getProgressLabel() {
      return $filter('translate')('assignments.' + ($scope.isAcademicProgram ? 'progress' : 'proficiency'));
    }

    function isDomainReport() {
      return $scope.progressData.focus_type === 'DOMAIN';
    }

    function getStudentStatusAlertClass(progressData) {
      if (progressData.isStatusCompleteStruggling) {
        return 'dbl-alert-box-red';
      } else if (progressData.isStatusCompleteForEngagement || progressData.isStatusCompleteForDevice) {
        return 'dbl-alert-box-blue';
      }
    }

    function getStudentStatusText(progressData) {
      if (progressData.isStatusCompleteStruggling) {
        return $filter('translate')('assignments.statusMessages.completeStruggling', progressData);
      } else if (progressData.isStatusCompleteForEngagement) {
        return $filter('translate')('assignments.statusMessages.completeForEngagement', progressData);
      } else if (progressData.isStatusCompleteForDevice) {
        return $filter('translate')('assignments.statusMessages.completeForDevice', progressData);
      }
    }

    function getAssignmentStatusClass() {
      var assignmentStatus = $scope.progressData.assignmentStatus;

      // For certain statuses use filter determine class, otherwise fall back to checking
      // the proficiency. The fallback handles the statuses like "Assignment Stopped" or "Incomplete".
      if (_.contains(SHOWABLE_ASSIGNMENT_STATUS_TEXTS, assignmentStatus)) {
        return $filter('statusLabel')(assignmentStatus);
      } else if (!$scope.goalReached && $scope.isPast) {
        return 'label-notify';
      } else if ($scope.goalReached) {
        return 'label-congratulate';
      }

      return '';
    }

    function getAssignmentStatusText() {
      var assignmentStatus = $scope.progressData.assignmentStatus;

      // For some statuses we can use the text directly; in other cases, fall back to checking
      // the proficiency. The fallback handles the statuses like "Assignment Stopped" or "Incomplete".
      if (_.contains(SHOWABLE_ASSIGNMENT_STATUS_TEXTS, assignmentStatus)) {
        return $filter('translate')('assignments.goalStatus.' + (assignmentStatus.toUpperCase().replace(/ /g, '_'))).toUpperCase();
      } else if (!$scope.goalReached && $scope.isPast) {
        return $filter('translate')('assignments.goalStatus.GOAL_NOT_REACHED');
      } else if ($scope.goalReached) {
        return $filter('translate')('assignments.goalStatus.GOAL_REACHED');
      }

      return '';
    }

    function shouldShowStudentStatusText(progressData) {
      return progressData.isStatusCompleteStruggling ||
        progressData.isStatusCompleteForEngagement ||
        progressData.isStatusCompleteForDevice;
    }

    function handlePlayDemoClick(lesson_slot_id) {
      dblLessonService.openPlayLessonLink(lesson_slot_id);
    }

    $scope.$watch('progressData', init);

    function cancel() {
      $modalInstance.dismiss('canceled by user');
    }

  }
})();
